import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const activityLocaleModule: LocaleModule = {
  name: "activity",
  messages: { en: en, it: it },
};
